const links = {
  home: [
    { page: "aktuellt", nameKey: "nav.aktuellt" },
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "about/history", nameKey: "nav.historia" },
    { page: "#gallery", nameKey: "nav.bilder" },
    { page: "contact", nameKey: "nav.kontakt" },
  ],
  stage: [
    { page: "../about/visit", nameKey: "nav.hittaHit" },
    { page: "/sponsorer", nameKey: "nav.varaSponsor" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "../", nameKey: "nav.hem" },
  ],
  welcome: [
    { page: "visit", nameKey: "nav.hittaHit" },
    { page: "history", nameKey: "nav.historia" },
    { page: "../#gallery", nameKey: "nav.bilder" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "../", nameKey: "nav.hem" },
  ],
  formular: [],
  visit: [
    { page: "welcome", nameKey: "nav.omOss" },
    { page: "history", nameKey: "nav.historia" },
    { page: "../#gallery", nameKey: "nav.bilder" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "../", nameKey: "nav.hem" },
  ],
  history: [
    { page: "welcome", nameKey: "nav.omOss" },
    { page: "visit", nameKey: "nav.hittaHit" },
    { page: "../#gallery", nameKey: "nav.bilder" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "../", nameKey: "nav.hem" },
  ],
  bilder: [
    { page: "aktuellt", nameKey: "nav.aktuellt" },
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "../", nameKey: "nav.hem" },
  ],
  menu: [
    { page: "aktuellt", nameKey: "nav.aktuellt" },
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "about/history", nameKey: "nav.historia" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "#gallery", nameKey: "nav.bilder" },
  ],
  aktuellt: [
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "about/history", nameKey: "nav.historia" },
    { page: "#gallery", nameKey: "nav.bilder" },
  ],
  open: [
    { page: "aktuellt", nameKey: "nav.aktuellt" },
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "about/history", nameKey: "nav.historia" },
    { page: "#gallery", nameKey: "nav.bilder" },
  ],
  contact: [
    { page: "aktuellt", nameKey: "nav.aktuellt" },
    { page: "about/welcome", nameKey: "nav.omOss" },
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "about/history", nameKey: "nav.historia" },
    { page: "#gallery", nameKey: "nav.bilder" },
  ],
  sponsorer: [
    { page: "about/visit", nameKey: "nav.hittaHit" },
    { page: "../contact", nameKey: "nav.kontakt" },
    { page: "/", nameKey: "nav.hem" },
  ],
};

export default links;
